import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AccordionCard } from 'src/components/AccordionCard';
import { ChiefComplaintSection } from '../../shared/components/ChiefComplaintSection';
import { PageTitle } from '../../shared/components/PageTitle';
import GeneralInfoCard from '../../shared/components/patient-info/GeneralInfoCard';
import { VerifiedPatientInfo } from '../../shared/components/patient-info/VerifiedPatientInfo';
import { IntakeNotes } from '../hooks/useIntakeNotes';

export const ChiefComplaintAndIntakeNotes: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing={1}>
      <PageTitle label={t('telemed.chart.chiefComplaintAndIntakeNotes')} showIntakeNotesButton={false} />

      <GeneralInfoCard />

      <VerifiedPatientInfo />

      <ChiefComplaintSection />

      <AccordionCard label={t('telemed.chart.intakeNotes')}>
        <IntakeNotes />
      </AccordionCard>
    </Stack>
  );
};
